// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"4524fe17","610":"3c3f6bdb"}[chunkId] + ".chunk.js";
};